import { render } from "./GradeModal.vue?vue&type=template&id=13529b0b&scoped=true"
import script from "./GradeModal.vue?vue&type=script&lang=js"
export * from "./GradeModal.vue?vue&type=script&lang=js"

import "./GradeModal.vue?vue&type=style&index=0&id=13529b0b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13529b0b"]])

export default __exports__